export default __webpack_public_path__ + "static/media/sorost.3f278d6c.svg";